module.exports = __webpack_public_path__ + "static/img/list-item-5.e3ce6ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-item-5.png
// module id = Ch6C
// module chunks = 1